module.exports = __webpack_public_path__ + "img/patient-record-mobile-en.d146ecdd.jpg";